import functions from "./functions";
import ImageZoom from "js-image-zoom";

function reviewButton(){
    $('.product-page').on('click', '[data-scroll]', function (){
        let nodeID = $(this).data('scroll'),
            $nodeID = $(nodeID);
        functions.windowScroll(nodeID);
        (!$nodeID.parent().hasClass('active')) ? $nodeID.click() : null;
    });
}

function checkReviewPopup(){
    let reviewForm = document.querySelector('.comment-form');
    if (reviewForm) {
        let submitBtn = reviewForm.querySelector('.submit');
        submitBtn.addEventListener('click', () => {
            if (!reviewForm.querySelector('.stars').classList.contains('selected')) {
                if (!reviewForm.querySelector('.red-error')) {
                    let error = document.createElement('span');
                    error.classList.add('red-error');
                    error.innerText = 'Oceń produkt';
                    reviewForm.querySelector('.stars').appendChild(error);
                }
            }
        });
    }
}

function labelRedirectURL(){
    $('.product-page').on('click', '.variations__option', function (){
        let optionActive = $(this).hasClass('active');
        if (!optionActive && !$(this).hasClass('disabled')) {
            let thisProductURL = $(this).data('product-url');
            if (thisProductURL) {
                window.location.assign(thisProductURL);
            }
        }
    });
}

function selectRadioInput(){

    $('.product-page').on('change', '.variation-radios input', function (){
        $('.variation-radios input:checked').each(function (index, element){
            let $el = $(element);
            let thisName = $el.attr('name');
            let thisVal = $el.attr('data-variation-value');
            let thisDataVariationId = $el.data('variation-id');

            $('.product__sub-slider')
                .find('img[data-variation-id=' + thisDataVariationId + ']')
                .click();

            $('select[name="' + thisName + '"]').val(thisVal).trigger('change');
            let createNewEvent = document.createEvent("HTMLEvents");
            createNewEvent.initEvent('change', true, true);
            let variationForm = document.querySelector('.variation-select');
            variationForm.dispatchEvent(createNewEvent);
        });
    });

    $('.variations_form').on('woocommerce_update_variation_values', function (){
        $('.variation-radios input').each(function (index, element){
            let $el = $(element);
            let thisName = $el.attr('name');
            let thisVal = $el.attr('value');
            $el.removeAttr('disabled');
            if ($('select[name="' + thisName + '"] option[value="' + thisVal + '"]').is(':disabled')) {
                $el.prop('disabled', true);
            }
        });
    });
}

function init(){

    if (functions.checkPage('product-page')) {

        reviewButton();
        selectRadioInput();
        labelRedirectURL();
        checkReviewPopup();

        const variationID = $('.variations__option.active').find('input').data('variation-id');
        (variationID) ? $('input[name=variation_id]').val(variationID) : null;

    }

}

export default {init};



// WEBPACK FOOTER //
// ./src/scripts/product-page.js